<template>
  <section>
    <div class="max-w-3xl">
      <h2 v-text="`${category} (${resources.length})`" />
      <div
        v-if="resources.length"
        class="flex flex-wrap items-stretch"
      >
        <div
          v-for="resource in resources"
          :key="`${resource.attributes.type}-${resource.uuid}`"
          class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
        >
          <LinkCard
            v-if="isLink(resource)"
            :link="resource"
          />
          <PageCard
            v-if="isPage(resource)"
            :page="resource"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script type="text/babel">
import LinkCard from './LinkCard'
import PageCard from './PageCard'

export default {
  name: 'Resources',
  components: {
    PageCard,
    LinkCard,
  },
  props: {
    resources: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    isDisabled() {
      return this.disabled
    },
    isActive() {
      return !this.disabled
    },
  },
  methods: {
    isLink(resource) {
      return resource.attributes._type === 'Link'
    },
    isPage(resource) {
      return resource.attributes._type === 'Page'
    },
  },
}
</script>
